import 'view/css/report.css';

import moment from 'moment';
import { useState, useEffect } from 'react';


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';

import API from 'service/api';
import Util from 'service/util';
import Loading from 'component/Loading';
import Protected from 'component/Protected';

import LHSTable from 'component/report/LHSTable';
import DatePicker from 'react-datepicker';

const LHSReportView = () =>
{
  const [loading, setLoading]     = useState(true);
  const [exporting, setExporting] = useState(false);

  const [rc_month, setMonth] = useState(new Date());
  const [data, setData] = useState([]);

  const exportXls = () =>
  {
    let ix = moment(rc_month).format('YYYYMM');
    setExporting(true);
    API.exportLHSReport(ix).then(resp => {
      const ix_date = moment().format('YYYYMMDD');
      Util.download(resp, `優悠家居報表_${ix_date}.xlsx`);
      setExporting(false);
    });
  }

  //----------------------------------------
  //- init
  useEffect(() => {
    if (!rc_month) return;
    setLoading(true);
    let ix = moment(rc_month).format('YYYYMM');
    API.getLHSReport(ix).then(data => {
      setData(data);
      setLoading(false);
    });
  }, [rc_month]);

  return (<>
    <h1>報表 - 優悠家居</h1>
    <p className="message blue">優悠家居月報。</p>
    <div className="action-panel">
      <div className="row search-bar">
        <label className="field">
          <strong>月份</strong>
          <DatePicker selected={rc_month} onChange={setMonth}
            dateFormat="MMM yyyy" showMonthYearPicker />
        </label>
      </div>
      <div>
        <Protected allow={['ADMIN']}>
          <button className="btn dark-green btn-export" disabled={!!exporting}
            onClick={exportXls}>
            <FontAwesomeIcon icon={faFileExcel} />
            <span> 匯出</span>
          </button>
        </Protected>
      </div>
    </div>
    <div className="lhs-report-body">
    {  loading
      ?<Loading />
      :<LHSTable data={data} />
    }
    </div>
  </>);

}

export default LHSReportView;